const state = {
  offerHistory: [],
  selectedOffer: null,
  isLoading: false,
};

const getters = {
  offerHistory: state => state.offerHistory,
  selectedOffer: state => state.selectedOffer,
  isLoading: state => state.isLoading,
};

const mutations = {
  setOfferHistory(state, history) {
    state.offerHistory = history;
  },
  setSelectedOffer(state, offer) {
    state.selectedOffer = offer;
  },
  setOfferLoading(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  getOfferHistory({ commit }) {
    commit('setOfferLoading', true);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('/offer/history')
        .then((response) => {
          commit('setOfferHistory', response.data.payload);
          resolve(response.data.payload);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit('setOfferLoading', false);
        });
    });
  },
  createOffer({ dispatch }, offerData) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/create', offerData)
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          console.error('Create offer error:', error);
          const errorMessage = (error && error.response && error.response.data) || 
                              (error && error.message) || 
                              'Something went wrong';
          reject(errorMessage);
        });
    });
  },
  acceptOffer({ dispatch }, offerId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/accept', { id: offerId })
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          console.error('Accept offer error:', error);
          const errorMessage = (error && error.response && error.response.data && error.response.data.message) || 
                              (error && error.response && error.response.data) || 
                              (error && error.message) || 
                              'Something went wrong';
          reject(errorMessage);
        });
    });
  },
  declineOffer({ dispatch }, offerId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/decline', { id: offerId })
        .then(() => {
          dispatch('getOfferHistory');
          resolve();
        })
        .catch((error) => {
          console.error('Decline offer error:', error);
          const errorMessage = (error && error.response && error.response.data && error.response.data.message) || 
                              (error && error.response && error.response.data) || 
                              (error && error.message) || 
                              'Something went wrong';
          reject(errorMessage);
        });
    });
  },
  requestPayoutCard({ dispatch }, payload) {
    console.log('Card payout payload:', payload);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/request-payout/card-form', payload)
        .then((response) => {
          resolve(response.data);
          dispatch('getOfferHistory');
        })
        .catch((error) => {
          console.error('Card payout error:', error);
          const errorMessage = (error && error.response && error.response.data && error.response.data.message) || 
                              (error && error.response && error.response.data) || 
                              (error && error.message) || 
                              'Something went wrong';
          reject(errorMessage);
        });
    });
  },
  requestPayoutIban({ dispatch }, payload) {
    console.log('IBAN payout payload:', payload);
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('/offer/request-payout/sepa-manual', payload)
        .then((response) => {
          console.log('IBAN payout success:', response);
          // Always refresh history after successful payout
          dispatch('getOfferHistory');
          resolve(response.data);
        })
        .catch((error) => {
          console.error('IBAN payout error:', error);
          
          // Handle different types of errors
          let errorData = 'Something went wrong';
          
          if (error && error.response && error.response.data) {
            const responseData = error.response.data;
            
            // Check if it's a structured error response with validation errors
            if (responseData.errors && typeof responseData.errors === 'object') {
              // Pass the entire response data so the component can handle field-specific errors
              errorData = responseData;
            } else if (typeof responseData === 'string') {
              errorData = responseData;
            } else if (responseData.message) {
              errorData = responseData.message;
            } else if (responseData.error) {
              errorData = responseData.error;
            } else {
              errorData = 'Server returned an error';
            }
          } else if (error && error.response) {
            errorData = `Server error: ${error.response.status}`;
          } else if (error && error.message) {
            // Network or other error
            errorData = error.message;
          } else if (error && typeof error === 'string') {
            errorData = error;
          }
          
          reject(errorData);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};